import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store.js'
import Search from './views/ReservationFlow1.vue'
import notify from './utils/notify/Notify.js'

Vue.use(VueRouter)

export default new VueRouter({
    routes: [
        {
            path: '/',
            beforeEnter (to, from, next) {
                if (to.query.action === 'password_reset') {
                    next({
                        path: '/password-reset',
                        query: {
                            action: 'password_reset',
                            uid: to.query.uid, 
                            token: to.query.token
                        }
                    })
                } else if (to.query.action === 'account_activate') {
                    next({
                        path: '/signin',
                        query: {
                            action: 'account_activate',
                            uid: to.query.uid, 
                            token: to.query.token
                        }
                    })
                } else {
                    next('/search')
                }
            }
        },
        {
            path: '/resource/:id',
            component: () => import(/* webpackChunkName: "resource" */ './components/booking/Resource.vue')
        },
        {
            path: '/booking/:id',
            component: () => import(/* webpackChunkName: "bookingform" */ './views/Booking.vue'),
            beforeEnter (to, from, next) {
                if (store.state.auth.sessionKey) {
                    next()
                } else {
                    notify('Du skal være logget ind for at kunne se reservationer')
                    next({
                        path: '/signin'
                    })
                }
            }
        },
        {
            path: '/booking/:id/edit',
            component: () => import(/* webpackChunkName: "bookingform" */ './components/booking/BookingEditForm.vue'),
            beforeEnter (to, from, next) {
                if (store.state.auth.sessionKey) {
                    next()
                } else {
                    notify('Du skal være logget ind for at kunne redigere reservationer')
                    next({
                        path: '/signin'
                    })
                }
            }
        },
        {
            path: '/search',
            component: Search,
            children: [
                {
                    path: '',
                    component: () => import(/* webpackChunkName: "bookingfilteredlist" */ './components/booking/FilteredResources.vue')
                },
                {
                    path: 'calendar',
                    component: () => import(/* webpackChunkName: "bookingcalendar" */ './components/booking/Calendar.vue')
                },
                {
                    path: 'schedule',
                    component: () => import(/* webpackChunkName: "bookingschedule" */ './components/booking/Schedule.vue')
                },
                {
                    path: 'bookingform',
                    component: () => import(/* webpackChunkName: "bookingform" */ './components/booking/BookingCreateForm.vue'),
                    beforeEnter (to, from, next) {
                        if (store.state.auth.sessionKey) {
                            next()
                        } else {
                            notify('Du skal være logget ind for at kunne reservere et lokale')
                            next({
                                path: '/signin',
                                query: { redirect: to.fullPath }
                            })
                        }
                    }
                }
            ]
        },
        {
            path: '/signup', 
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "signup" */ './components/auth/Signup.vue')
        },
        {
            path: '/signup-success', 
            component: () => import(/* webpackChunkName: "signupsuccess" */ './components/auth/SignupSuccess.vue')
        },
        {
            path: '/signin', 
            component: () => import(/* webpackChunkName: "signin" */ './components/auth/Signin.vue'),
            beforeEnter (to, from, next) {
                if (!store.state.auth.sessionKey) {
                    next()
                } else {
                    if (store.state.auth.user.is_staff) {
                        next({
                            path: '/dashboard'
                        })
                    } else {
                        next({
                            path: '/my-bookings'
                        })
                    }
                }
            }
        },
        {
            path: '/password-reset',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "signup" */ './components/auth/Resetpassword.vue')
        },
        {
            path: '/dashboard',
            component: () => import(/* webpackChunkName: "dashboard" */ './views/Dashboard.vue'),
            beforeEnter (to, from, next) {
                if (store.state.auth.sessionKey) {
                    next()
                } else {
                    next({
                        path: '/signin',
                        query: { redirect: to.fullPath }
                    })
                }
            }
        },
        {
            path: '/my-bookings',
            component: () => import(/* webpackChunkName: "mybookings" */ './views/MyBookings.vue'),
            beforeEnter (to, from, next) {
                if (store.state.auth.sessionKey) {
                    next()
                } else {
                    next({
                        path: '/signin',
                        query: { redirect: to.fullPath }
                    })
                }
            }
        },
        {
            path: '/bookinglist',
            component: () => import(/* webpackChunkName: "mybookings" */ './components/booking_admin/BookingAdminList.vue'),
            beforeEnter (to, from, next) {
                if (store.state.auth.sessionKey && store.state.auth.user.is_staff) {
                    next()
                } else {
                    next({
                        path: '/signin',
                        query: { redirect: to.fullPath }
                    })
                }
            }
        },
        {
            path: '/bookinglist/:id/edit',
            component: () => import(/* webpackChunkName: "bookingform" */ './components/booking_admin/BookingAdminEdit.vue'),
            beforeEnter (to, from, next) {
                if (store.state.auth.sessionKey && store.state.auth.user.is_staff) {
                    next()
                } else {
                    next({
                        path: '/signin'
                    })
                }
            }
        },
        {
            path: '/profile',
            component: () => import(/* webpackChunkName: "profile" */ './views/Profile.vue'),
            beforeEnter (to, from, next) {
                if (store.state.auth.sessionKey) {
                    next()
                } else {
                    next({
                        path: '/signin',
                        query: { redirect: to.fullPath }
                    })
                }
            }
        },
        {
            path: '/terms', 
            component: () => import(/* webpackChunkName: "terms" */ './views/Terms.vue')
        }
    ]
})